import { render } from "./Privacidade.vue?vue&type=template&id=1ca62e80&scoped=true"
import script from "./Privacidade.vue?vue&type=script&lang=js"
export * from "./Privacidade.vue?vue&type=script&lang=js"

import "./Privacidade.vue?vue&type=style&index=0&id=1ca62e80&lang=css"
import "./Privacidade.vue?vue&type=style&index=1&id=1ca62e80&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca62e80"]])

export default __exports__